import { useEffect, useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { Loader2, Camera, ChevronDown, ChevronUp, CheckCircle2, Circle } from "lucide-react";
import InspectionPanel from "@/components/admin/InspectionPanel";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

function Dot({ ok, label }) {
  return (
    <span className={`inline-flex items-center gap-1 text-xs ${ok ? "text-green-400" : "text-white/35"}`}>
      {ok ? <CheckCircle2 size={13} /> : <Circle size={13} />} {label}
    </span>
  );
}

export default function InspectionsTab({ token, onAuthError }) {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);
  const [open, setOpen] = useState(null);

  const load = async () => {
    setLoading(true);
    try {
      const { data } = await axios.get(`${API}/inspections`, { headers: { Authorization: `Bearer ${token}` } });
      setRows(data || []);
    } catch (e) {
      if (e?.response?.status === 401 && onAuthError) onAuthError();
      else toast.error("Failed to load inspections");
    } finally { setLoading(false); }
  };
  useEffect(() => { load(); /* eslint-disable-next-line */ }, []);

  if (loading) return <div className="flex justify-center py-16"><Loader2 className="animate-spin text-[#F2B705]" /></div>;

  return (
    <div className="space-y-3" data-testid="inspections-tab">
      <div>
        <h2 className="text-xl font-bold text-white">Vehicle Inspections</h2>
        <p className="text-white/50 text-sm">Pre-trip &amp; post-trip condition records. Synced with each booking — edits here show on the booking too.</p>
      </div>
      {rows.length === 0 && <p className="text-white/40">No active bookings to inspect.</p>}
      {rows.map((r) => (
        <div key={r.booking_id} className="rounded-lg bg-[#0C0C0C] border border-white/10 overflow-hidden" data-testid={`inspection-row-${r.booking_id}`}>
          <button onClick={() => setOpen(open === r.booking_id ? null : r.booking_id)}
            data-testid={`inspection-toggle-${r.booking_id}`}
            className="w-full flex items-center justify-between gap-3 px-4 py-3 text-left hover:bg-white/[0.02]">
            <div className="min-w-0">
              <div className="font-semibold text-white truncate">{r.name} <span className="text-white/40 font-normal">· {r.vehicle}</span></div>
              <div className="text-white/40 text-xs">{r.pickup_date} → {r.return_date}</div>
            </div>
            <div className="flex items-center gap-3 shrink-0">
              <Dot ok={!!r.pre} label="Pre" />
              <Dot ok={!!r.post} label="Post" />
              {open === r.booking_id ? <ChevronUp size={16} className="text-white/40" /> : <ChevronDown size={16} className="text-white/40" />}
            </div>
          </button>
          {open === r.booking_id && (
            <div className="p-4 border-t border-white/10">
              <InspectionPanel bookingId={r.booking_id} token={token} />
            </div>
          )}
        </div>
      ))}
    </div>
  );
}
